import React from 'react';

// Style sheets
import Style from './Key.module.scss';

export function Key(props){
    const Title = props.title;
    const Color = props.color;
    const Background = props.background;
    const Wide = props.wide;

    return(
        <button aria-label={Title} onClick={() => props.onClick(Title)}
            className={Wide === "Wide" 
                ? `${Style.Button} ${Style[Color]} ${Style[Background]} ${Style[Wide]}` : `${Style.Button} ${Style[Color]} ${Style[Background]}`
            }>
            {Title}
        </button>
    );
}